import React from 'react';
import { Box, Button } from '@mui/material';
import { SubmitActionProps } from './types';

type ActionsProps = {
    submitActions: Array<SubmitActionProps>;
};

const Actions: React.FunctionComponent<ActionsProps> = function ({ submitActions }) {
    const actionText = ({ type, label }: Partial<SubmitActionProps>) => {
        if (!label) {
            return type === 'confirm' ? 'Confirmer' : 'Annuler';
        }

        return label;
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                gap: '10px',
                alignSelf: 'stretch',
            }}
        >
            {submitActions.map(({ type, action, label, disabled }) => (
                <Button
                    key={type}
                    variant="contained"
                    color={type === 'confirm' ? 'primary' : 'error'}
                    onClick={action}
                    disabled={disabled}
                >
                    {actionText({ type, label })}
                </Button>
            ))}
        </Box>
    );
};

export default Actions;
